module.exports = __webpack_public_path__ + "assets/img/17_946.f65a5bbc.jpg";